import combineAddressParts from './combineAddressParts';

export default function combineTokenisedAddress({
  unit,
  streetNumber,
  streetName,
  suburb,
  postcode,
  state,
}: TokenisedAddress): string {
  return combineAddressParts([
    ...(streetNumber != null && unit != null
      ? [`${unit}/${streetNumber}`]
      : [unit, streetNumber]),
    streetName,
    suburb,
    postcode,
    state,
  ]);
}
